module.exports = __webpack_public_path__ + "img/3a6cf9fa-146d-4780-b4c0-ca2521bf05e3.f27e55cb.jpg";